/* ============================================================
   LE SURPLUS MILITAIRE - Design "page legale" sur les policies
   Shopify rend les /policies/* via un markup fige (.shopify-policy__
   container). Ce script reconstruit autour le design refonte :
   hero sombre (fil d'ariane + titre + derniere MAJ), mise en page
   deux colonnes avec sommaire collant (nav entre docs + sommaire
   interne + carte aide). Contenu serveur intact ; chrome en JS.
   Auto-guarde : ne fait rien hors page policy. Em-dash free.
   ============================================================ */
(function () {
  "use strict";

  var DOCS = [
    { h: "legal-notice",     l: "Mentions légales" },
    { h: "privacy-policy",   l: "Confidentialité" },
    { h: "terms-of-sale",    l: "Conditions de vente" },
    { h: "terms-of-service", l: "Conditions d'utilisation" },
    { h: "shipping-policy",  l: "Politique d'expédition" },
    { h: "refund-policy",    l: "Retours & remboursement" }
  ];

  function pad2(n) { return ("0" + n).slice(-2); }
  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }
  function slug(s) {
    return s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  function frDate(s) {
    if (!s) return "";
    var p = s.split("/");
    if (p.length !== 3) return s;
    var m = ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"];
    var d = parseInt(p[0], 10), mo = parseInt(p[1], 10), y = p[2];
    if (!m[mo - 1]) return s;
    return d + " " + m[mo - 1] + " " + y;
  }

  function init() {
    var cont = document.querySelector(".shopify-policy__container");
    if (!cont || cont.getAttribute("data-rf-done")) return;
    var titleEl = cont.querySelector(".shopify-policy__title h1");
    var bodyEl = cont.querySelector(".shopify-policy__body");
    if (!bodyEl) return;
    cont.setAttribute("data-rf-done", "1");

    var title = (titleEl ? titleEl.textContent : "Informations légales").trim();
    var seg = (location.pathname.split("/policies/")[1] || "");
    var curHandle = seg.split("/")[0].split("?")[0];

    /* --- Extrait la mention "derniere mise a jour" du corps pour la remonter dans le hero --- */
    var updated = "";
    Array.prototype.slice.call(bodyEl.querySelectorAll("em")).forEach(function (em) {
      var t = em.textContent || "";
      var mm = t.match(/(\d{1,2}\/\d{1,2}\/\d{2,4})/);
      if (mm && /(jour|modif)/i.test(t)) {
        updated = mm[1];
        var p = em.closest ? em.closest("p") : null;
        (p || em).remove();
      }
    });
    var updatedFr = frDate(updated);

    /* --- Sommaire interne depuis les H2 --- */
    var h2s = Array.prototype.slice.call(bodyEl.querySelectorAll("h2"));
    var toc = h2s.map(function (h, i) {
      var id = h.id || ("sec-" + (slug(h.textContent) || i));
      h.id = id;
      h.style.scrollMarginTop = "96px";
      return { id: id, t: h.textContent.trim(), i: i };
    });

    /* --- HERO --- */
    var hero = document.createElement("section");
    hero.className = "lsm-rf rf-pol-hero";
    hero.innerHTML =
      '<div class="rf-wrap rf-pol-hero-inner">' +
        '<nav class="rf-pol-crumbs" aria-label="Fil d\'ariane">' +
          '<a href="/">Accueil</a><span class="rf-sl">/</span>' +
          '<span>Informations légales</span><span class="rf-sl">/</span>' +
          '<span>' + esc(title) + '</span>' +
        '</nav>' +
        '<h1>' + esc(title) + '</h1>' +
        (updatedFr
          ? '<span class="rf-pol-updated"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>Dernière mise à jour : <b>' + esc(updatedFr) + '</b></span>'
          : '') +
      '</div>';

    /* --- ASIDE (nav docs + sommaire + aide) --- */
    var idxHtml = DOCS.map(function (d, i) {
      var active = d.h === curHandle ? ' class="active"' : "";
      return '<li><a href="/policies/' + d.h + '"' + active + '><span class="n">' + pad2(i + 1) + '</span>' + esc(d.l) + '</a></li>';
    }).join("");
    var tocHtml = toc.map(function (it) {
      return '<li><a data-target="' + it.id + '"><span class="tn">' + pad2(it.i + 1) + '</span>' + esc(it.t) + '</a></li>';
    }).join("");

    var band = document.createElement("div");
    band.className = "lsm-rf rf-pol-band";
    band.innerHTML =
      '<div class="rf-wrap"><div class="rf-pol-layout">' +
        '<aside class="rf-pol-aside">' +
          '<nav class="rf-pol-index" aria-label="Documents légaux"><h4>Informations légales</h4><ul>' + idxHtml + '</ul></nav>' +
          (toc.length > 1
            ? '<nav class="rf-pol-toc" aria-label="Sommaire du document"><h6>Dans ce document</h6><ol>' + tocHtml + '</ol></nav>'
            : '') +
          '<div class="rf-pol-help">' +
            '<span class="rf-pol-help-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span>' +
            '<h5>Une question ?</h5>' +
            '<p>Le service client répond du lundi au vendredi, 8h-18h, sous 24h ouvrées.</p>' +
            '<a href="/pages/contact">Nous contacter <span aria-hidden="true">→</span></a>' +
          '</div>' +
        '</aside>' +
        '<article class="rf-pol-doc"></article>' +
      '</div></div>';

    /* --- Restructuration DOM --- */
    var parent = cont.parentNode;
    parent.insertBefore(hero, cont);
    parent.insertBefore(band, cont);
    band.querySelector(".rf-pol-doc").appendChild(bodyEl);
    cont.parentNode.removeChild(cont);
    document.body.classList.add("rf-pol-ready");

    /* --- Sommaire : defilement doux --- */
    Array.prototype.slice.call(band.querySelectorAll(".rf-pol-toc a[data-target]")).forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        var t = document.getElementById(a.getAttribute("data-target"));
        if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 88, behavior: "smooth" });
      });
    });

    /* --- Sommaire : etat actif au scroll --- */
    var links = Array.prototype.slice.call(band.querySelectorAll(".rf-pol-toc a[data-target]"));
    if (links.length) {
      var onScroll = function () {
        var y = window.pageYOffset + 120, cur = toc[0].id;
        toc.forEach(function (it) {
          var el = document.getElementById(it.id);
          if (el && el.offsetTop <= y) cur = it.id;
        });
        links.forEach(function (l) { l.classList.toggle("active", l.getAttribute("data-target") === cur); });
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
